import { invokeApi } from "../../bl_libs/invokeApi";

export const _get_payment_settings = async (data) => {
  const requestObj = {
    path: `api/website_settings/get_general_settings`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
// payment_settings
export const _add_payment_settings = async (data) => {
  const requestObj = {
    path: `api/website_settings/add_payment_settings`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
